import Phaser from 'phaser';
import { GAME_CONFIG } from '../config/game';
import { getSoundSystem } from '../systems/SoundSystem';
import { getLevelTimeStars } from '../systems/StarRating';
import { BackHandler, pushSceneState } from '../systems/BackButton';

export class GameOverScene extends Phaser.Scene implements BackHandler {
  private level = 1;
  private score = 0;
  private bestScore = 0;
  private timeAttack = false;
  private daily = false;
  private dailyDate = '';
  private elapsedMs = 0;

  constructor() {
    super('GameOverScene');
  }

  handleBack(): void {}

  init(data: { level: number; score: number; bestScore: number; timeAttack?: boolean; elapsedMs?: number; daily?: boolean; dailyDate?: string }): void {
    this.level = data.level;
    this.score = data.score;
    this.bestScore = data.bestScore;
    this.timeAttack = data.timeAttack ?? false;
    this.daily = data.daily ?? false;
    this.dailyDate = data.dailyDate ?? '';
    this.elapsedMs = data.elapsedMs ?? 0;
  }

  create(): void {
    pushSceneState();
    const centerX = GAME_CONFIG.width / 2;
    const baseY = GAME_CONFIG.height / 2 - 50;

    this.add.text(centerX, baseY - 120, 'The Volcano Has Spoken', {
      fontSize: '24px',
      color: '#ff6b6b',
      fontFamily: 'sans-serif',
    }).setOrigin(0.5);

    this.add.text(centerX, baseY - 70, 'The land must rest for now...', {
      fontSize: '16px',
      color: '#aaaaaa',
      fontFamily: 'sans-serif',
    }).setOrigin(0.5);

    const subtitle = this.daily ? `Daily Challenge: ${this.dailyDate}` : `Level ${this.level}`;
    this.add.text(centerX, baseY - 30, subtitle, {
      fontSize: '20px',
      color: '#ffffff',
      fontFamily: 'sans-serif',
    }).setOrigin(0.5);

    if (this.timeAttack) {
      this.add.text(centerX, baseY + 10, `Time: ${this.formatTime(this.elapsedMs)}`, {
        fontSize: '18px',
        color: '#ffffff',
        fontFamily: 'sans-serif',
      }).setOrigin(0.5);

      const existing = getLevelTimeStars(this.level);
      if (existing) {
        this.add.text(centerX, baseY + 40, `Best: ${this.formatTime(existing.bestTime)}`, {
          fontSize: '16px',
          color: '#888888',
          fontFamily: 'sans-serif',
        }).setOrigin(0.5);
      }
    } else {
      this.add.text(centerX, baseY + 10, `Score: ${this.score}`, {
        fontSize: '18px',
        color: '#ffffff',
        fontFamily: 'sans-serif',
      }).setOrigin(0.5);

      this.add.text(centerX, baseY + 40, `Best: ${this.bestScore}`, {
        fontSize: '16px',
        color: '#888888',
        fontFamily: 'sans-serif',
      }).setOrigin(0.5);
    }

    this.createButtons(centerX, baseY);
  }

  private createButtons(centerX: number, baseY: number): void {
    const retryBtn = this.add.text(centerX, baseY + 110, 'Try Again', {
      fontSize: '22px',
      color: '#1a1a2e',
      fontFamily: 'sans-serif',
      backgroundColor: this.timeAttack ? '#7ec8e3' : '#a8e6cf',
      padding: { x: 32, y: 16 },
    }).setOrigin(0.5).setInteractive();

    retryBtn.on('pointerdown', () => {
      getSoundSystem().playBlip();
      if (this.daily) {
        this.scene.start('GameScene', { daily: true, date: this.dailyDate });
      } else {
        this.scene.start('GameScene', { level: this.level, timeAttack: this.timeAttack });
      }
    });

    const navLabel = this.daily ? 'Calendar' : 'World Map';
    const navColor = this.daily ? '#f0d060' : this.timeAttack ? '#7ec8e3' : '#a8e6cf';
    const navTarget = this.daily ? 'DailyCalendarScene' : 'WorldMapScene';

    const mapBtn = this.add.text(centerX, baseY + 180, navLabel, {
      fontSize: '18px',
      color: navColor,
      fontFamily: 'sans-serif',
    }).setOrigin(0.5).setInteractive();

    mapBtn.on('pointerdown', () => {
      getSoundSystem().playBlip();
      this.scene.start(navTarget);
    });

    const menuBtn = this.add.text(centerX, baseY + 220, 'Main Menu', {
      fontSize: '18px',
      color: '#888888',
      fontFamily: 'sans-serif',
    }).setOrigin(0.5).setInteractive();

    menuBtn.on('pointerdown', () => {
      getSoundSystem().playBlip();
      this.scene.start('TitleScene');
    });
  }

  private formatTime(ms: number): string {
    const totalSeconds = ms / 1000;
    if (totalSeconds >= 60) {
      const minutes = Math.floor(totalSeconds / 60);
      const seconds = Math.floor(totalSeconds % 60);
      return `${minutes}:${String(seconds).padStart(2, '0')}`;
    }
    return `${totalSeconds.toFixed(1)}s`;
  }
}
